var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.addVirtualFileSystem(pdfFonts);
//pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  Calibri: {
    normal: 'calibri.ttf',
    bold: 'calibrib.ttf',
    italics: 'calibrii.ttf',
    bolditalics: 'calibriz.ttf'
  }
}

const FileSaver = require("file-saver");
const { logoString } =  require('/src/assets/js/logo.js');
const JSZip = require("jszip");



module.exports = function(qipInfo, attachment) {
    var zip = new JSZip();
    var pdf = zip.folder("QIP for QCR# " + qipInfo.QCRnumber);

    var QIP_PDF = {
        content: [
        { image: 'logo', width: 500, height: 75 },
        { text: '690 Discovery Dr NW | Huntsville, AL 35806', style: 'smolHeader' },
        { text: '256.327.3410 Office | QuadrusCorp.com', style: 'smolHeader' },
        { text: 'QIP for QCR #' + qipInfo.QCRnumber, style: 'header', margin: [0,10]},
        
        {
            table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 0,
            widths: [ '*', '*'],
    
            body: [
                [ { text: 'QIP-1 Author', bold: true }, qipInfo.author1],
                [ { text: 'QIP-2 Author', bold: true }, qipInfo.author2]
            ]
            }
        },
        
        { text: '1. Introduction', bold: true, margin: [0, 12]},
        { text: qipInfo.introduction },
        { text: '1.1 QCR Description', bold: true, margin: [0, 12]},
        { text: qipInfo.description },
        { text: '2. Design Analysis ', bold: true, margin: [0, 12]},
        { text: '2.1 Recommeded Design Approach', bold: true, margin: [0, 12]},
        { text: qipInfo.designApproach },
        { text: '2.2 Alternate Design Approach', bold: true, margin: [0, 12]},
        { text: qipInfo.designApproach2 },
        { text: '3. Affected Documents', bold: true, margin: [0, 12]},
        { text: '3.1 User Manual', bold: true, margin: [0, 12]},
        { text: qipInfo.userManual },
        { text: '3.2 Requirements Documentation', bold: true, margin: [0, 12]},
        { text: qipInfo.requirements },
        { text: '3.3 Design Documentation', bold: true, margin: [0, 12]},
        { text: qipInfo.designDoc },
        { text: '3.4 Software Development Plan', bold: true, margin: [0, 12]},
        { text: qipInfo.developmentPlan },
        { text: '3.5 Software Test Plan', bold: true, margin: [0, 12]},
        { text: qipInfo.testPlan },
        { text: '3.6 Formal Qualification Test Procedure', bold: true, margin: [0, 12]},
        { text: qipInfo.fqtProcedure },
        { text: '3.7 Software Test Report', bold: true, margin: [0, 12]},
        { text: qipInfo.testReport },
        { text: '3.8 Process Documentation', bold: true, margin: [0, 12]},
        { text: qipInfo.processDoc },
        { text: '3.9 Other Documentation', bold: true, margin: [0, 12]},
        { text: qipInfo.otherDoc },
        { text: '4. Required Non-Labor Resources', bold: true, margin: [0, 12]},
        { text: qipInfo.resources },
        { text: '5. Required Travel', bold: true, margin: [0, 12]},
        { text: qipInfo.travel },
        { text: '6. Design Details', bold: true, margin: [0, 12]},
        { text: '6.1 Functionality Changes', bold: true, margin: [0, 12]},
        { text: '6.1.1 Changes to Product', bold: true, margin: [0, 12]},
        { text: '6.1.1.1 Class', bold: true, margin: [0, 12]},
        { text: qipInfo.className },
        { text: '6.2 Integration', bold: true, margin: [0, 12]},
        { text: qipInfo.integration },
        { text: '6.3 Interfaces', bold: true, margin: [0, 12]},
        { text: '6.3.1 External Interfaces', bold: true, margin: [0, 12]},
        { text: qipInfo.externalInterfaces },
        { text: '6.3.2 Internal Interfaces', bold: true, margin: [0, 12]},
        { text: qipInfo.internalInterfaces },
        { text: '6.4 Reuse', bold: true, margin: [0, 12]},
        { text: qipInfo.reuse },
        ],
        images: {
        logo: logoString
        },
        styles: {
            header: {
                fontSize: 16,
                bold: true,
                alignment: 'center'
            },
            smolHeader: {
                fontSize: 10,
                alignment: 'center'
            }
        },
        defaultStyle: {
        font: 'Calibri'
        },
        info: {
        title: 'QIP'
        }
    }

    var pdfData = pdfMake.createPdf(QIP_PDF);
    pdfData.getBlob(blob => {
        pdf?.file(
            `QIP for QCR ${qipInfo.QCRnumber}.pdf`,
            blob,
            { binary: true }
        );
    }); 

    if (attachment) {
        pdf.file(qipInfo.qipDocs.attributes.name, attachment);
    }

    zip.generateAsync({type:"blob"}).then(function () {
        zip.generateAsync({type:"blob"})
            .then(function(content) {FileSaver.saveAs(content, "QIP for QCR# " + qipInfo.QCRnumber + ".zip");});
        });
}
